import { useTranslation } from '@kostbar/i18n'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Slider } from '@/components/ui/slider'

interface Props {
  value: {
    slotDurationMinutes: number
    serviceStartLocal: string
    serviceEndLocal: string
  }
  onChange: (next: Props['value']) => void
}

export function SlotsForm({ value, onChange }: Props) {
  const { t: tRestaurants } = useTranslation('restaurants')
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
        <div>
          <Label>{tRestaurants('scheduling.slots.durationLabel')}</Label>
          <div className="flex items-center gap-3">
            <Slider
              min={5}
              max={60}
              step={5}
              value={[value.slotDurationMinutes]}
              onValueChange={(v) =>
                onChange({ ...value, slotDurationMinutes: v[0] })
              }
              className="w-56"
            />
            <div className="w-10">{value.slotDurationMinutes}</div>
          </div>
        </div>
        <div>
          <Label>{tRestaurants('scheduling.slots.serviceStartLabel')}</Label>
          <Input
            type="time"
            value={value.serviceStartLocal}
            onChange={(e) =>
              onChange({ ...value, serviceStartLocal: e.target.value })
            }
          />
        </div>
        <div>
          <Label>{tRestaurants('scheduling.slots.serviceEndLabel')}</Label>
          <Input
            type="time"
            value={value.serviceEndLocal}
            onChange={(e) =>
              onChange({ ...value, serviceEndLocal: e.target.value })
            }
          />
        </div>
      </div>
    </div>
  )
}
